"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
exports.setDefaultGrpcClientHostname = setDefaultGrpcClientHostname;
exports.getDefaultGrpcClientHostname = getDefaultGrpcClientHostname;
exports.setDefaultGrpcClientPort = setDefaultGrpcClientPort;
exports.getDefaultGrpcClientPort = getDefaultGrpcClientPort;
exports.setDefaultGrpcTls = setDefaultGrpcTls;
exports.getDefaultGrpcTls = getDefaultGrpcTls;
exports.setDefaultGrpcAuthToken = setDefaultGrpcAuthToken;
exports.setGrpcAuthTokenFn = setGrpcAuthTokenFn;
exports.createClient = createClient;
exports.getServiceName = getServiceName;
exports.getClientAddress = getClientAddress;
exports.getClientHostname = getClientHostname;
exports.getClientPort = getClientPort;
const change_case_1 = require("change-case");
const events_1 = require("events");
const keys_1 = __importDefault(require("lodash/keys"));
const first_1 = __importDefault(require("lodash/first"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const firstGrpc = __importStar(require("../generated/stronachgroup/first"));
let defaultGrpcClientHostname = "localhost";
let defaultGrpcClientPort = "8080";
let defaultGrpcTls = false;
let defaultGrpcAuthToken;
let grpcAuthTokenFn;
if (typeof process !== "undefined" && typeof process.env !== "undefined") {
    defaultGrpcClientHostname =
        process.env.GRPC_WEB_CLIENT_HOST || defaultGrpcClientHostname;
    defaultGrpcClientPort =
        process.env.GRPC_WEB_CLIENT_PORT || defaultGrpcClientPort;
    defaultGrpcTls =
        (process.env.GRPC_WEB_TLS && process.env.GRPC_WEB_TLS === "1") ||
            defaultGrpcTls;
    defaultGrpcAuthToken = process.env.GRPC_WEB_AUTH_TOKEN;
}
else if (typeof window !== "undefined" &&
    typeof window.location !== "undefined" &&
    typeof window.location.hostname === "string") {
    const hostname = window.location.hostname;
    if (!hostname.startsWith("localhost")) {
        defaultGrpcTls = true;
        defaultGrpcClientPort = "443";
        if (/^(?:.+\.)?dev\./.test(hostname) ||
            /^(?:.+\.)?preprod\./.test(hostname)) {
            defaultGrpcClientHostname = hostname;
        }
        else {
            defaultGrpcClientHostname = "api.1stbet.com";
        }
    }
}
function setDefaultGrpcClientHostname(hostname) {
    defaultGrpcClientHostname = hostname;
}
function getDefaultGrpcClientHostname() {
    return defaultGrpcClientHostname;
}
function setDefaultGrpcClientPort(port) {
    defaultGrpcClientPort = port;
}
function getDefaultGrpcClientPort() {
    return defaultGrpcClientPort;
}
function setDefaultGrpcTls(tls) {
    defaultGrpcTls = tls;
}
function getDefaultGrpcTls() {
    return defaultGrpcTls;
}
function setDefaultGrpcAuthToken(token) {
    defaultGrpcAuthToken = token;
}
function setGrpcAuthTokenFn(fn) {
    grpcAuthTokenFn = fn;
}
function createClient(clientType, packageName, options = {}) {
    const address = options.address ||
        getClientAddress(packageName, getServiceName(clientType));
    const client = new clientType(address, null, { withCredentials: true });
    const auth = options.auth || grpcAuthTokenFn || defaultGrpcAuthToken;
    if (auth) {
        const client_ = client.client_;
        const proxyMeta = proxyAuthMetadata(auth);
        const rpcCall = client_.rpcCall;
        client_.rpcCall = (method, request, metadata, methodInfo, callback) => proxyStreamFn(proxyMeta, metadata, callback, meta => rpcCall.call(client_, method, request, meta, methodInfo, (err, response) => {
            callback(err, response);
        }));
        client_.unaryCall = async (method, request, metadata, methodInfo) => {
            return new Promise((resolve, reject) => {
                client_.rpcCall(method, request, metadata, methodInfo, (error, response) => {
                    if (error) {
                        reject(error);
                        return;
                    }
                    resolve(response);
                });
            });
        };
        const serverStreaming = client_.serverStreaming;
        client_.serverStreaming = (method, request, metadata, methodInfo) => proxyStreamFn(proxyMeta, metadata, undefined, meta => serverStreaming.call(client_, method, request, meta, methodInfo));
    }
    return client;
}
function proxyStreamFn(proxyMeta, metadata, callback, streamFn) {
    let callStream;
    let cancelled = false;
    const emitter = new events_1.EventEmitter();
    proxyMeta(metadata)
        .then(meta => {
        callStream = streamFn(meta);
        if (cancelled) {
            callStream.cancel();
        }
        if (!callback) {
            callStream.on("error", error => {
                emitter.emit("error", error);
            });
            callStream.on("data", response => {
                emitter.emit("data", response);
            });
            callStream.on("status", status => {
                emitter.emit("status", status);
            });
            callStream.on("end", () => {
                emitter.emit("end");
            });
        }
    })
        .catch(error => {
        if (callback) {
            callback(error, null);
        }
        else {
            emitter.emit("error", error);
        }
    });
    return Object.assign(emitter, {
        cancel: () => {
            if (callStream) {
                callStream.cancel();
            }
            cancelled = true;
        }
    });
}
function getServiceName(serverOrClientType) {
    let name = serverOrClientType.name;
    if ("service" in serverOrClientType &&
        typeof serverOrClientType.service === "object") {
        const serviceDefinition = serverOrClientType.service;
        const firstMethodName = (0, first_1.default)((0, keys_1.default)(serviceDefinition).filter(k => typeof serviceDefinition[k].path === "string"));
        if (firstMethodName) {
            const firstMethod = serviceDefinition[firstMethodName];
            name = /^\/.+\.([\dA-Za-z]+)\/.+$/.exec(firstMethod.path)[1] || name;
        }
    }
    if (name.endsWith("PromiseClient")) {
        name = name.substring(0, name.length - 13);
    }
    else if (name.endsWith("Client")) {
        name = name.substring(0, name.length - 6);
    }
    else if (name.endsWith("ClientAsync")) {
        name = name.substring(0, name.length - 11);
    }
    name = name.replace(/([\da-z])([A-Z])/g, "$1-$2").toLowerCase();
    return name;
}
function getClientAddress(packageName, serviceName) {
    const tls = defaultGrpcTls;
    const port = getClientPort(packageName, serviceName);
    let portSuffix = "";
    if ((tls && port !== "80") || (!tls && port !== "443")) {
        portSuffix = `:${port}`;
    }
    return `http${tls ? "s" : ""}://${getClientHostname(packageName, serviceName)}${portSuffix}`;
}
function getClientHostname(packageName, serviceName) {
    if (typeof process === "undefined" || typeof process.env === "undefined") {
        return defaultGrpcClientHostname;
    }
    return (process.env.GRPC_CLIENT_HOST ||
        process.env[`${toEnvVariableName(trimRootPackage(packageName))}_${toEnvVariableName(serviceName)}_GRPC_HOST`] ||
        process.env[`${toEnvVariableName(serviceName)}_GRPC_HOST`] ||
        (typeof process.env.MY_NAMESPACE === "string"
            ? `${serviceName}.${process.env.MY_NAMESPACE}.svc.cluster.local`
            : defaultGrpcClientHostname));
}
function getClientPort(packageName, serviceName) {
    if (typeof process === "undefined" || typeof process.env === "undefined") {
        return defaultGrpcClientPort;
    }
    return (process.env.GRPC_CLIENT_PORT ||
        process.env[`${toEnvVariableName(trimRootPackage(packageName))}_${toEnvVariableName(serviceName)}_GRPC_PORT`] ||
        process.env[`${toEnvVariableName(serviceName)}_GRPC_PORT`] ||
        defaultGrpcClientPort);
}
var Status;
(function (Status) {
    Status[Status["OK"] = 0] = "OK";
    Status[Status["CANCELLED"] = 1] = "CANCELLED";
    Status[Status["UNKNOWN"] = 2] = "UNKNOWN";
    Status[Status["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    Status[Status["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    Status[Status["NOT_FOUND"] = 5] = "NOT_FOUND";
    Status[Status["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    Status[Status["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    Status[Status["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    Status[Status["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    Status[Status["ABORTED"] = 10] = "ABORTED";
    Status[Status["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    Status[Status["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    Status[Status["INTERNAL"] = 13] = "INTERNAL";
    Status[Status["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    Status[Status["DATA_LOSS"] = 15] = "DATA_LOSS";
    Status[Status["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
})(Status || (exports.Status = Status = {}));
function trimRootPackage(packageName) {
    if (packageName.startsWith(firstGrpc.packageName)) {
        return packageName.substring(firstGrpc.packageName.length + 1);
    }
    else {
        return packageName;
    }
}
function toEnvVariableName(serviceName) {
    return (0, change_case_1.constantCase)(serviceName);
}
function proxyAuthMetadata(authTokenOrFn) {
    let authFn;
    if (typeof authTokenOrFn === "function") {
        authFn = authTokenOrFn;
    }
    else {
        authFn = async () => authTokenOrFn;
    }
    return async (metadata) => {
        const authToken = await authFn();
        if (authToken &&
            ((0, isEmpty_1.default)(metadata) ||
                ((0, isEmpty_1.default)(metadata.Authorization) && (0, isEmpty_1.default)(metadata.authorization)))) {
            metadata = metadata || {};
            metadata.Authorization = authToken.startsWith("Bearer ")
                ? authToken
                : `Bearer ${authToken}`;
        }
        return metadata || {};
    };
}
//# sourceMappingURL=index.js.map